import {
  CheckMetadata,
  ComparisonCheckType,
  createAttributeComparisonTableCheckMetadatas,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { IdNfcAttributeComparison } from 'dashboard/models/check';

export const computeIdNfcAttributeComparisonMetadata = (
  check: IdNfcAttributeComparison,
): CheckMetadata => {
  const metadata = check.metadata;

  if (metadata && metadata['attribute-comparisons']) {
    return {
      metadata: createAttributeComparisonTableCheckMetadatas(
        metadata['attribute-comparisons'],
        ComparisonCheckType.IdNfcAttributeComparison,
      ),
      hideIfVerificationPassed: false,
    };
  }

  return {
    metadata: [],
    hideIfVerificationPassed: false,
  };
};
